import {
  getCheckedEmotionRating,
  getSelectedCheckBoxItems,
} from './toString';

export const formattedUserFeedbackFormData = (formData, uid, timer, userIP, hasCompletedUserFeedback) => {
  return {
    coaching_methodology_rating: Number(formData.coachingMethodologyRating),
    coaching_methodology_rating_factors: getSelectedCheckBoxItems(
      formData.coachingMethodologyRatingFactors
    ),
    coaching_methodology_feedback: formData.coachingMethodologyFeedback,
    growth_support_feedback: formData.growthSupportFeedback,
    process_improvement_feedback: formData.processImprovementFeedback,
    flash_coach_platform_rating: Number(formData.flashCoachPlatformRating),
    flash_coach_training_rating: Number(
      getCheckedEmotionRating(formData.flashCoachTrainingRating)
    ),
    ease_of_navigation_rating: Number(
      getCheckedEmotionRating(formData.easeOfNavigationRating)
    ),
    ease_of_navigation_feedback: formData.easeOfNavigationFeedback,
    accessibility_rating: Number(
      getCheckedEmotionRating(formData.accessibilityRating)
    ),
    accessibility_factors: getSelectedCheckBoxItems(
      formData.accessibilityFactors
    ),
    accessibility_factors_others: formData.accessibilityFactorsOthers,
    helpful_features: getSelectedCheckBoxItems(formData.helpfulFeatures),
    helpful_features_others: formData.helpfulFeaturesOthers,
    improvement_suggestion: formData.improvementSuggestion,
    support_rating: Number(formData.supportRating),
    user_uid: uid,
    time_taken: timer,
    language: "en",
    ip_address: userIP,
    has_completed_user_feedback: hasCompletedUserFeedback,
  }
}